import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';
import footerImagesInfo from '../../assets/footerInfo/footerImgs';
import InstagramFooterIcon from '../Icons/InstagramFooterIcon';

const Footer = () => {
  const { t } = useTranslation();

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);
  return (
    <footer className={styles.footerContainer} role='contentinfo'>
      <h2 className={styles.title}>{t('lang.footerTitle')}</h2>
      <div className={styles.imagesContainer}>
        <a
          className={styles.facebookIcon}
          target='_blank'
          rel='noreferrer'
          href='https://www.instagram.com/vikyvivavi/'
          // href="https://www.facebook.com/viktoriia.perfilieva"
        >
          {/* <FacebookFooterIcon /> */}
          <InstagramFooterIcon />
          {/* <InstagramFooterIconDesktop /> */}
        </a>

        {footerImagesInfo?.map((item, idx) => (
          <div className={styles.imageWrap} key={idx}>
            <div className={styles.imageMask}></div>
            <img className={styles.image} src={item.link} alt={item.alter} />
          </div>
        ))}

        {/* <div className={styles.imageWrap}>
          <div className={styles.imageMask}></div>
          <img
            className={styles.image}
            src="https://i.ibb.co/pQT8tLs/facebook-img4.jpg"
            alt=""
          />
        </div>
        <div className={styles.imageWrap}>
          <div className={styles.imageMask}></div>
          <img
            className={styles.image}
            src="https://i.ibb.co/ck3941R/facebook-img5.jpg"
            alt=""
          />
        </div>
        <div className={styles.imageWrap}>
          <div className={styles.imageMask}></div>
          <img
            className={styles.image}
            src="https://i.ibb.co/MZXww2T/facebook-img6.jpg"
            alt=""
          />
        </div>
        <div className={styles.imageWrap}>
          <div className={styles.imageMask}></div>
          <img
            className={styles.image}
            src="https://i.ibb.co/rmxpbLn/facebook-img3.jpg"
            alt=""
          />
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
